import { render, staticRenderFns } from "./IcoThunder.vue?vue&type=template&id=645411af"
import script from "./IcoThunder.vue?vue&type=script&lang=js"
export * from "./IcoThunder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports